import { getLocalTimezone, isTimezoneValid } from '@capital-access/common/utils';

export function resolveTimezone(preferenceValue: string | null) {
  if (preferenceValue && isTimezoneValid(preferenceValue)) {
    // use timezone from preference
    return preferenceValue;
  }
  return getLocalTimezone();
}
